import axios from "axios";
import QS from "qs";

// 封装get方法
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

// 封装post方法
export function post(url, params, callback = null) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, QS.stringify(params))
            .then(res => {
                callback ? resolve(callback(res.data)) : resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

// 上传文件
export function upload(url, params, file, fileName = null, callback = null) {
    let formData = new FormData();
    if (fileName) {
        formData.append("file", file, fileName);
    } else {
        formData.append("file", file);
    }

    let uri = "",
        item;
    for (item in params) {
        if (params[item] && String(params[item])) {
            uri += uri === "" ? "?" : "&";
            uri += `${item}=${decodeURI(params[item])}`;
        }
    }

    return new Promise((resolve, reject) => {
        axios
            .post(url + uri, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            })
            .then(res => {
                callback ? resolve(callback(res.data)) : resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

// 本地用的假数据方法
export function local(data, timeout = 0) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve({
                code: 1,
                data: data
            });
        }, timeout);
    });
}
